import type { BaseComponentProps } from "@/shared/ui/base/BaseComponent";

export const LoadingScreen = ({ className }: BaseComponentProps) => (
  <div
    className={`min-h-screen flex items-center justify-center bg-gray-50 ${className ?? ""}`.trim()}
  >
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500" />
  </div>
);
